import { useCallback } from 'react';

import useIntersection from './useIntersection';

const useIntersectionAutoplayRef = (options?: IntersectionObserverInit) => {
  const handleIntersect: IntersectionObserverCallback = useCallback(([entry]) => {
    if (entry.target instanceof HTMLVideoElement) {
      if (entry.isIntersecting) {
        entry.target.play().catch(() => null);
      } else {
        entry.target.pause();
      }
    }
  }, []);

  const { observerRef } = useIntersection(handleIntersect, options);

  return observerRef;
};

export default useIntersectionAutoplayRef;
